export enum QuestionInputTypeEnum {
  textarea = "textarea",
  select = "select",
}
